<template>
  <nav class="header-nav" ref="navRef">
    <div class="nav-content">
      <span class="nav-logo">HypnoMaker</span>

      <!-- Desktop links -->
      <div class="nav-links desktop-only">
        <router-link to="/">Home</router-link>
        <router-link to="/docs">Documentation</router-link>
        <router-link to="/faq">FAQ</router-link>
        <router-link to="/changelog">Changelog</router-link>

        <a href="https://www.reddit.com/r/HypnoMaker/" target="_blank" rel="noopener noreferrer" class="ext-link">
          <img src="/assets/reddit.png" alt="Reddit" class="nav-icon" />
        </a>
        <a href="https://twitter.com/RemedyHM" target="_blank" rel="noopener noreferrer" class="ext-link">
          <img src="/assets/twitter.png" alt="X" class="nav-icon" />
        </a>
      </div>

      <!-- Mobile actions: social + hamburger -->
      <div class="nav-actions mobile-only">
        <a href="https://www.reddit.com/r/HypnoMaker/" target="_blank" rel="noopener noreferrer" class="icon-link" aria-label="Reddit">
          <img src="/assets/reddit.png" alt="Reddit" class="nav-icon" />
        </a>
        <a href="https://twitter.com/RemedyHM" target="_blank" rel="noopener noreferrer" class="icon-link" aria-label="X">
          <img src="/assets/twitter.png" alt="X" class="nav-icon" />
        </a>

        <button
          class="hamburger"
          :class="{ open }"
          @click="toggle()"
          aria-label="Menu"
          aria-controls="primary-menu"
          :aria-expanded="open.toString()"
        >
          <span></span><span></span><span></span>
        </button>
      </div>
    </div>

    <!-- Mobile dropdown -->
    <div id="primary-menu" class="mobile-menu" v-show="open">
      <router-link to="/" @click="close()">Home</router-link>
      <router-link to="/docs" @click="close()">Documentation</router-link>
      <router-link to="/faq" @click="close()">FAQ</router-link>
      <router-link to="/changelog" @click="close()">Changelog</router-link>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const open = ref(false)
const navRef = ref(null)

function toggle() { open.value = !open.value }
function close() { open.value = false }

function onKey(e) {
  if (e.key === 'Escape') close()
}
function onClickAway(e) {
  if (!navRef.value) return
  if (!navRef.value.contains(e.target)) close()
}

onMounted(() => {
  window.addEventListener('keydown', onKey)
  window.addEventListener('click', onClickAway)
})
onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKey)
  window.removeEventListener('click', onClickAway)
})
</script>

<style scoped>
/* Reuse your existing styles and add these tweaks */

.nav-actions { display: flex; align-items: center; gap: 12px; }
.icon-link { display: inline-flex; align-items: center; }

.nav-icon {
  height: 26px;
  width: 26px;
  object-fit: contain;
  vertical-align: middle;
}

.ext-link {
  color: #f8f6fb;
  margin-left: 2.2rem;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  opacity: 0.95;
  transition: color 0.12s;
}
.ext-link:hover { color: #391a67; opacity: 1; }

/* Hamburger */
.hamburger {
  appearance: none;
  border: 0;
  background: transparent;
  width: 32px; height: 24px;
  display: inline-flex; flex-direction: column; justify-content: space-between;
  padding: 0; cursor: pointer;
}
.hamburger span {
  display: block; height: 3px; width: 100%;
  background: #f8f6fb; border-radius: 2px; transition: transform .18s, opacity .18s;
}
.hamburger.open span:nth-child(1) { transform: translateY(10px) rotate(45deg); }
.hamburger.open span:nth-child(2) { opacity: 0; }
.hamburger.open span:nth-child(3) { transform: translateY(-10px) rotate(-45deg); }

/* Mobile menu panel */
.mobile-menu {
  background: #feb1dc;
  border-top: 1px solid #e47ebc50;
  box-shadow: 0 6px 12px #e47ebc30;
  display: flex;
  flex-direction: column;
  margin-top: 10px; /* Match your navbar height */
}
.mobile-menu a {
  color: #f8f6fb;
  text-decoration: none;
  font-weight: 600;
  padding: 12px 2vw;
  border-bottom: 1px solid #e47ebc30;
}
.mobile-menu a:last-child { border-bottom: 0; }
.mobile-menu a:hover { color: #391a67; }

/* Responsive visibility */
.desktop-only { display: flex; align-items: center; }
.mobile-only  { display: none; align-items: center; gap: 12px; }

@media (max-width: 600px) {
  .desktop-only { display: none; }
  .mobile-only  { display: flex; }
}
</style>
